import { render, staticRenderFns } from "./StoreUnitCard.vue?vue&type=template&id=53ac145d&"
import script from "./StoreUnitCard.vue?vue&type=script&lang=js&"
export * from "./StoreUnitCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports